<template>
  <a :class="['button', className]" href="#!" @click.prevent="saveProduct"><slot /></a>
</template>
<script>

import { eventBus } from '../app';

export default {
	props: {
		product: {
			type: Object, 
			default: null
		},
		type: {
			type: String, 
			default: null
		},
		className: {type: [String, Array, Object], default: ''}
	},
	data() {
		return {
			selectedProduct: this.product,
			itemType: this.type
		};
	},
	methods: {
		saveProduct() {
			eventBus.$emit('save-product', { type: this.type, item: this.selectedProduct });
		}
	}
};
</script>
